export default class Enum {
    static all () {
        return Object.values(this);
    }
}